import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/navbar/Navbar";
import Footer from './components/footer/Footer'
import Home from './pages/navPages/HomePage';
import AboutUs from "./pages/navPages/AboutUs";
import ContactUs from "./pages/navPages/ContactUs";
import Products from "./pages/navPages/Products";
import ProductDetails from "./pages/navPages/ProductDetails";
import Certificates from "./pages/navPages/Certificates";
import PaymentTerms from "./pages/navPages/PaymentTerms";
import OrganicProducts from "./pages/navPages/OrganicProducts";


const App = () => {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/about" exact element={<AboutUs />} />
          <Route path="/contactus" exact element={<ContactUs />} />
          <Route path="/products" exact element={<Products />} />
          <Route path="/product/:id" element={<ProductDetails />} />          
          <Route path="/certification" exact element={<Certificates/>} />
           <Route path="/payment" exact element={<PaymentTerms/>} />
           {/* <Route path="/organic-products-pdf" element={<OrganicProducts />} /> */}

        </Routes>
        <Footer/>
      </Router>
    </>
  );
};

export default App;
